/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isObject, objectHasPropertyString } from "utils/empty-exists";
import { cloneObjectsArray } from "utils/array";
import { LinkSelectorWrapper } from "cms/links/link-selector/link-selector-wrapper";
import { ComponentCTAContext } from "cms/components/components/call-to-action/edit/component-cta-context";
import { Logger } from "cms/utils/log/logger";

const CTALink = () => {
    
    const { token } = useAuth();
    const {
        item,
        index,
        list,
        updateItems
    } = useContext(ComponentCTAContext) || {};

    const [link, setLink] = useState();
    const [linkGuid, setLinkGuid] = useState();
    const [loadingLink, setLoadingLink] = useState(false);
    const { link: guid } = item || {};

    const loadLink = async () => {
        if (guid && guid.length > 30) {
            const _link = await SimpliCityAdminSDK.link.findOne(token, guid);
            setLink(_link);
            return _link;
        }
    };

    useEffect(() => {
        const load = async () => {
            if (Object.keys(item).length > 0) {
                setLoadingLink(true);
                setLinkGuid(list[index]);
                const _link = await loadLink(guid);
                setLink(_link);
                setLoadingLink(false);
            }
        };
        // load once
        if (!isObject(link) || !objectHasPropertyString(link, "guid") || link?.link !== item?.link) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item]);

    const onChangeLink = async (link) => {
        setLink(link);
        const updatedLinks = cloneObjectsArray(list);
        updatedLinks[index].link = link?.guid;
        updatedLinks[index].position = index;
        Logger.debug(updatedLinks);
        updateItems(updatedLinks);
    };
    const onRemoveLink = async () => {
        setLink(undefined);
        setLinkGuid(undefined);
        const updatedLinks = cloneObjectsArray(list);
        updatedLinks[index].link = "";
        updateItems(updatedLinks);
    };

    return (
        <div style={{ flex: "1" }}>
            <LinkSelectorWrapper
                link={link}
                setLink={setLink}
                linkGuid={linkGuid}
                setLinkGuid={setLinkGuid}
                onLinkChange={(link) => onChangeLink(link)}
                onLinkRemove={() => onRemoveLink()}
                disabled={false}
                loadingLink={loadingLink}
                setLoadingLink={setLoadingLink}
            />
        </div>
    );
};

export { CTALink };
